import { render, staticRenderFns } from "./NoticeboardPush.vue?vue&type=template&id=23f800ad"
import script from "./NoticeboardPush.vue?vue&type=script&lang=js"
export * from "./NoticeboardPush.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports